import React from "react";
import styled from "styled-components";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  LinkedinShareButton,
  LinkedinIcon,
  EmailShareButton,
  EmailIcon,
} from "react-share";
import {
  ArticleSharingMethod,
  useRecordArticleShared,
} from "hooks/analytics/useRecordArticleShared";

const ShareLinkButtonsContainer = styled.div.attrs({
  className: "flex items-center justify-center py-2",
})``;

const ShareButtonContainer = styled.div.attrs({
  className: "m-1 cursor-pointer",
})``;

const ShareLinkButtons = ({ link, story }: { link: string; story?: any }) => {
  const recordArticleShared = useRecordArticleShared();
  const title = `Check out this article from The Juggernaut. I'm a subscriber, so you'll be able to read it for free! `;

  return (
    <ShareLinkButtonsContainer>
      <ShareButtonContainer>
        <FacebookShareButton
          beforeOnClick={() => {
            if (story) {
              recordArticleShared(story, ArticleSharingMethod.facebook);
            }
          }}
          url={link}
          title={title}
        >
          <FacebookIcon size={32} round />
        </FacebookShareButton>
      </ShareButtonContainer>
      <ShareButtonContainer>
        <WhatsappShareButton
          beforeOnClick={() => {
            if (story) {
              recordArticleShared(story, ArticleSharingMethod.whatsapp);
            }
          }}
          url={link}
          title={title}
          separator={"\n"}
        >
          <WhatsappIcon size={32} round />
        </WhatsappShareButton>
      </ShareButtonContainer>
      <ShareButtonContainer>
        <TwitterShareButton
          beforeOnClick={() => {
            if (story) {
              recordArticleShared(story, ArticleSharingMethod.twitter);
            }
          }}
          url={link}
          title={title}
          via={"bethejuggernaut"}
        >
          <TwitterIcon size={32} round />
        </TwitterShareButton>
      </ShareButtonContainer>
      <ShareButtonContainer>
        <EmailShareButton
          beforeOnClick={() => {
            if (story) {
              recordArticleShared(story, ArticleSharingMethod.email);
            }
          }}
          url={link}
          subject={`The Juggernaut: ${story?.title}`}
          body={`${title} \n\n ${story?.title} \n\n ${story?.summary} \n\n`}
        >
          <EmailIcon size={32} round bgStyle={{ fill: "#353535" }} />
        </EmailShareButton>
      </ShareButtonContainer>
      <ShareButtonContainer>
        <LinkedinShareButton
          beforeOnClick={() => {
            if (story) {
              recordArticleShared(story, ArticleSharingMethod.linkedin);
            }
          }}
          url={link}
        >
          <LinkedinIcon size={32} round />
        </LinkedinShareButton>
      </ShareButtonContainer>
    </ShareLinkButtonsContainer>
  );
};

export default ShareLinkButtons;
